import React, { PropTypes } from 'react'
import { Link } from 'react-router'

import './SearchNoResultsSecondTimeUser.scss'

import { formatLongDate, format24hTime } from 'utils/dates'
import * as paths from 'utils/paths'

function SearchNoResultsSecondTimeUser ({ searchProps, configureSetup }) {
  const {
    estimatedHours,
    date,
    time
  } = searchProps

  const formattedDate = formatLongDate(date)
  const formattedTime = format24hTime(time)

  return (
    <div className='SearchNoResultsSecondTimeUser'>
      <div className='SearchNoResultsSecondTimeUser-content'>
        <p>
          No encontramos Aliadas para un servicio de <strong>{estimatedHours} horas</strong> el <strong>{formattedDate}</strong> a las <strong>{formattedTime}</strong>.
        </p>

        <p>
          Intenta reduciendo la cantidad de horas del servicio o cambiando la fecha del servicio.
        </p>
      </div>

      <div className='SearchNoResultsSecondTimeUser-buttons'>
        <Link
          className='SearchNoResultsSecondTimeUser-button btn btn-primary'
          to={paths.serviceSetupStep(1)}
          onClick={configureSetup}
          >
          Cambiar duración
        </Link>

        <Link
          className='SearchNoResultsSecondTimeUser-button btn btn-primary'
          to={paths.serviceSetupStep(2)}
          onClick={configureSetup}
          >
          Cambiar fecha
        </Link>
      </div>
    </div>
  )
}

SearchNoResultsSecondTimeUser.propTypes = {
  searchProps: PropTypes.shape({
    estimatedHours: PropTypes.number.isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired
  }).isRequired
}
export default SearchNoResultsSecondTimeUser



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/SearchResults/components/SearchNoResultsSecondTimeUser/SearchNoResultsSecondTimeUser.js